import '../../sass/plugins/carousel.scss';

import { EXTRA_SMALL_SCREEN, LARGE_SCREEN, SMALL_SCREEN } from '../consts';

$(() => {
  const nextArrow = '#carousel-next-arrow';
  const prevArrow = '#carousel-prev-arrow';

  $('.slider-for-carousel-entry').each((_, elem) => {
    console.log($(this));
    $(elem).slick({
      slidesToScroll: 1,
      fade: true,
      prevArrow: $(elem).parent().find(prevArrow),
      nextArrow: $(elem).parent().find(nextArrow),
      responsive: [
        {
          breakpoint: EXTRA_SMALL_SCREEN,
          settings: {
            centerPadding: '50px',
            dots: true,
          },
        },
        {
          breakpoint: SMALL_SCREEN,
          settings: {
            centerPadding: '30px',
            dots: true,
          },
        },
        {
          breakpoint: LARGE_SCREEN,
          settings: {
            centerPadding: '30px',
            dots: true,
          },
        },
      ],
    });
  });
});
